<form class="flex flex-col flex-1 bg-grey-lightest px-5 py-4 gap-4">
	<div class="flex justify-end items-center mt-2">
		<div
			class="flex w-[220px] justify-center gap-x-2"
			[matTooltip]="syncTooltip"
		>
			<app-icon
				[ngClass]="treefortSyncAvailable ? 'text-green' : 'text-grey-light'"
				[icon]="syncIcon"
			></app-icon>
			<span
				[ngClass]="treefortSyncAvailable ? 'text-green' : 'text-grey-light'"
				>{{ syncText }}</span
			>
		</div>
	</div>
	<div class="flex justify-between items-center">
		<span>ID Type</span>
		<span *ngIf="!Ids?.length" class="text-grey">{{ IDLabels[id?.type] }}</span>
		<app-dropdown
			*ngIf="Ids?.length"
			placeholder="Select ID type"
			[itemGroups]="[{ items: Ids, template: itemTemplate }]"
			name="identification-type-dropdown"
			class="max-h-24 flex max-w-220"
			(onSelect)="_setType($event)"
			[ngModel]="selectedID?.displayText"
		>
		</app-dropdown>
	</div>
	<div class="flex justify-between items-center">
		<span>Name on ID</span>
		<app-input
			class="max-h-24 flex max-w-220"
			[ngModel]="id?.fullName"
			(debounce)="_setFullName($event)"
			name="fullName"
		></app-input>
	</div>
	<div class="flex justify-between items-center">
		<span>ID Number</span>
		<app-input
			class="max-h-24 flex max-w-220"
			[ngModel]="id?.number"
			(debounce)="_setNumber($event)"
			name="number"
		></app-input>
	</div>
	<div class="flex justify-between items-center">
		<span>Expiration Date</span>
		<app-date-picker
			class="max-h-24 flex max-w-220"
			name="expirationDate"
			[ngModel]="id?.expirationDate"
			(ngModelChange)="_setExpirationDate($event)"
		></app-date-picker>
	</div>
	<div class="flex justify-between items-center">
		<span>Issuing Jurisdiction</span>
		<app-input
			class="max-h-24 flex max-w-220"
			[ngModel]="id?.jurisdiction"
			(debounce)="_setJurisdiction($event)"
			name="jurisdiction"
		></app-input>
	</div>
	<div class="flex justify-between items-center">
		<span>Country</span>
		<app-input
			class="max-h-24 flex max-w-220"
			[ngModel]="id?.country"
			(debounce)="_setCountry($event)"
			name="country"
		></app-input>
	</div>
	<div class="flex justify-between items-center">
		<span>Verified By</span>
		<app-input
			class="max-h-24 flex max-w-220"
			[ngModel]="id?.verifiedBy"
			[disabled]="id?.verifiedBy"
			(debounce)="_setVerifiedBy($event)"
			name="verifiedBy"
		></app-input>
	</div>
	<div class="flex justify-between items-center">
		<span>Verified Date</span>
		<app-date-picker
			class="max-h-24 flex max-w-220"
			name="verifiedDate"
			[ngModel]="id?.dateOfVerification"
			[disabled]="id?.dateOfVerification"
			(ngModelChange)="_setVerifiedDate($event)"
		></app-date-picker>
	</div>
</form>

<ng-template #itemTemplate let-item>
	<p class="truncate max-w-[186px]">{{ item?.displayText }}</p>
</ng-template>
